import { Component } from '@angular/core';
import { App, NavParams, ViewController, Platform } from 'ionic-angular';
import { SharingProvider } from '../../providers/sharing/sharing';
import { Instagram } from '@ionic-native/instagram';
import { TransferObject, Transfer } from '@ionic-native/transfer';
import { Base64ToGallery, Base64ToGalleryOptions } from '@ionic-native/base64-to-gallery';
import { Observable, Observer } from 'rxjs';
import { ConfigProvider } from '../../providers/config/config';
import { AppDetectorProvider } from '../../providers/detector/detector';

declare var cordova: any;

@Component({
    selector: 'popup-registration',
    templateUrl: 'popup-registration.html'
})
export class PopupRegistrationComponent {
    event: any = null;
    registration: any = null;
    startDisabled: boolean = false;

    //UI
    noAddResultButton: boolean = false;
    updater: boolean = true;

    color: string = "black";

    appId: string = "";

    constructor(
        public app: App,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        private sharingService: SharingProvider,
        private instagram: Instagram,
        private transfer: Transfer,
        private platform: Platform,
        private config: ConfigProvider,
        private base64ToGallery: Base64ToGallery,
        private appDetector: AppDetectorProvider
    ) {
        new Promise<any>(async (resolve, reject) => {
            this.event = this.navParams.get('event');
            this.registration = this.navParams.get('registration');
            this.noAddResultButton = (await this.config.config).showHide.noResultAddButton;
            this.color = (await this.config.config).theme.color;
            this.appId = (await this.config.config).appId;

            if (this.appDetector.isHellaApp()) {
                this.color = "#002f5d"
            }

            this.color = (this.appId.toLocaleLowerCase().includes('event')) ? "black" : this.color;

            this.isEventStarted();
        });
    }

    ionViewDidLoad() {
        this.updater = false;
        setTimeout(() => {
            this.updater = true;
        }, 100);
    }


    isEventStarted() {

        //if event's started then we unable start buttons
        //returns if event has started

        let startDate = new Date(this.event.date);

        let midnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0);

        this.startDisabled = (midnight.getTime() - new Date().getTime() < 0) ? false : true;

        // this.startDisabled = false;

        return !this.startDisabled;
    }

    onDismiss(value) {
        this.viewCtrl.dismiss(value);
    }

    onPostFB() {
        // this.sharingService.share("ui/showEvent.jsf?cid=" + this.event.cid + "&id=" + this.event.id);
        this.sharingService.shareFacebook('', this.registration.imageLink);
    }

    onPostInstagram() {
        let imageUrl = this.registration.imageLink;
        let base64Image = "";
        this.getBase64ImageFromURL(imageUrl).subscribe(base64data => {
            console.log(base64data);
            base64Image = 'data:image/jpeg;base64,' + base64data;
            // if (this.platform.is('ios')) {
            //     this.convertToImage(base64data);
            // } else {
            //     this.instagram.share(base64Image);
            // }
            this.instagram.share(base64Image).then(() => {
                console.log('The image is shared via Instagram!');
            }).catch(err => {
                console.log(err);
                console.log('The image was not shared via Instagram!');
            });
        });
    }


    convertToImage(image) {
        let config: Base64ToGalleryOptions = {
            prefix: 'img_',
            mediaScanner: true
        };

        console.log('image: ', image);

        this.base64ToGallery.base64ToGallery(image, config).then(
            res => {
                this.downloadFile(null);
            },
            err => console.log('Error saving image to gallery ', err)
        );
    }

    downloadFile(link) {
        this.platform.ready().then(() => {

            const fileTransfer: TransferObject = this.transfer.create();

            let storageDirectory = "";

            const imageLocation = this.registration.imageLink;

            if (this.platform.is('ios')) {
                storageDirectory = cordova.file.documentsDirectory;
            }
            else if (this.platform.is('android')) {
                storageDirectory = cordova.file.dataDirectory;
            }

            let image = imageLocation + ".jpeg";

            console.log('storageDirectory: ', storageDirectory);
            fileTransfer.download(imageLocation, storageDirectory + image).then((entry) => {
                console.log('entry: ', entry.toURL());
                this.instagram.shareAsset(entry.toURL()).then(() => {
                    console.log('succes INSTAGRAM');
                });
            }, (error) => {
                console.log(error);
            });

        });
    }

    getBase64ImageFromURL(url: string) {
        return Observable.create((observer: Observer<string>) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            if (!img.complete) {
                img.onload = () => {
                    observer.next(this.getBase64Image(img));
                    observer.complete();
                };
                img.onerror = (err) => {
                    observer.error(err);
                };
            } else {
                observer.next(this.getBase64Image(img));
                observer.complete();
            }
        });
    }

    getBase64Image(img: HTMLImageElement) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    }


}



// WEBPACK FOOTER //
// /src/components/popup-registration/popup-registration.ts